export default __webpack_public_path__ + "static/media/blog-post-layout-01-img-07.35df1f37.jpg";